import { Box, Skeleton } from '@mui/material'
import React from 'react'

const HomeContentSkeleton = () => {
    const containerStyles = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        pt: '20px',
    }
    const skeletonStylesFirstRow = {
        bgcolor: 'grey.800',
        maxWidth: '580px',
        maxHeight: '350px',
        width: '100vw',
        height: '100vh',
        mb: '20px',
        ml: '20px',
    }

    const skeletonStylesSecondRow = {
        ...skeletonStylesFirstRow,
        maxWidth: '180px',
        maxHeight: '140px',
    }
    const skeletonStylesVodRow = {
        ...skeletonStylesFirstRow,
        maxWidth: '237px',
        maxHeight: '400px',
    }
    return (
        <Box sx={containerStyles}>
            <Box display="flex" mr="20px">
                {[...Array(3).keys()].map((index) => (
                    <Skeleton
                        sx={skeletonStylesFirstRow}
                        key={index}
                        animation="wave"
                        variant="rectangular"
                    />
                ))}
            </Box>
            <Box display="flex" mr="20px">
                {[...Array(9).keys()].map((index) => (
                    <Skeleton
                        sx={skeletonStylesSecondRow}
                        key={index}
                        animation="wave"
                        variant="rectangular"
                    />
                ))}
            </Box>
            <Box display="flex" mr="20px">
                {[...Array(7).keys()].map((index) => (
                    <Skeleton
                        sx={skeletonStylesVodRow}
                        key={index}
                        animation="wave"
                        variant="rectangular"
                    />
                ))}
            </Box>
            <Box display="flex" mr="20px">
                {[...Array(7).keys()].map((index) => (
                    <Skeleton
                        sx={skeletonStylesVodRow}
                        key={index}
                        animation="wave"
                        variant="rectangular"
                    />
                ))}
            </Box>
        </Box>
    )
}

export default HomeContentSkeleton
